import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=bb8a4888&lang=html&"
import script from "./navbar.vue?vue&type=script&lang=js&"
export * from "./navbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Devdoc\\_packages\\moss-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb8a4888')) {
      api.createRecord('bb8a4888', component.options)
    } else {
      api.reload('bb8a4888', component.options)
    }
    module.hot.accept("./navbar.vue?vue&type=template&id=bb8a4888&lang=html&", function () {
      api.rerender('bb8a4888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/navbar.vue"
export default component.exports